import type { SVGProps } from 'react';

const SvgPlayerMarker = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M15 20H9c-1.65 0-3-1.35-3-3v-5.3c0-.68.23-1.35.66-1.88l3.64-4.54c.37-.47.93-.74 1.53-.75h.03c.58 0 1.14.25 1.52.7l3.9 4.55c.46.54.72 1.24.72 1.95v5.26c0 1.65-1.35 3-3 3z"
    />
  </svg>
);
export default SvgPlayerMarker;
